import React, { memo, useCallback, useMemo } from 'react';
import { getLiteral } from 'utils/getLiteral';
import Decimal from 'containers/components/Fields/Decimal';
import { getDecimalsByConfig, DECIMAL_TYPES } from 'utils/decimal';
import './styles.scss';

const DiscountRow = memo(
    ({ label, value, onChange, isHidden, isReadOnly, fieldId, salesOrderData }) => {
        const onDecimalChange = useCallback(
            (value) => {
                onChange && onChange(value);
            },
            [onChange],
        );

        const limitDecimals = useMemo(() => {
            let idEnvironment = salesOrderData?.idEnvironment || salesOrderData?.idBranch;
            let idCurrency = salesOrderData?.idCurrency;

            if (idEnvironment && typeof idEnvironment === 'object' && idEnvironment.value) {
                idEnvironment = idEnvironment.value;
            }

            if (idCurrency && typeof idCurrency === 'object' && idCurrency.value) {
                idCurrency = idCurrency.value;
            }

            return getDecimalsByConfig({
                entityName: 'SALESORDERS',
                fieldId,
                idCurrency,
                idEnvironment,
                type: DECIMAL_TYPES.GENERAL,
            });
        }, [
            fieldId,
            salesOrderData?.idBranch,
            salesOrderData?.idCurrency,
            salesOrderData?.idEnvironment,
        ]);

        if (isHidden) return null;

        return (
            <div className="sales-order-product-lines__crud-widget__content__discount">
                <Decimal
                    label={`${getLiteral(label)} (%)`}
                    labelMode="horizontal"
                    fieldId={fieldId}
                    limitDecimals={limitDecimals}
                    onChange={onDecimalChange}
                    readOnly={isReadOnly}
                    value={value ?? ''}
                />
            </div>
        );
    },
);

DiscountRow.displayName = 'DiscountRow';

export default DiscountRow;
